module.exports = __webpack_public_path__ + "assets/img/arrow-right-blue.a13d2629.svg";